import React from "react";
import PropTypes from "prop-types";

import { strCode } from "../../../../consts";
import { t } from "../../../../services";

import { Features, GeneralSettings } from "../../../../containers";
import { FlexContainers, WrapperContainer } from "../../../../components";
import { ManagemenetPageTitle } from "./styled";

export const GeneralTab = ({ isUpdate }) => {
  return (
    <WrapperContainer
      width={"100%"}
      alignItems={"flex-start"}
      Container={FlexContainers.FlexColumn}
      pr={24}>
      <ManagemenetPageTitle>{t(strCode.BASIC_INFO_TITLE_SHORT)}</ManagemenetPageTitle>

      <GeneralSettings isUpdate={isUpdate} />
      <Features />
    </WrapperContainer>
  );
};

GeneralTab.propTypes = {
  isUpdate: PropTypes.number
};
